import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {ListWrapper} from './list/ListWrapper'

const roomBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/rooms',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const RoomPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={roomBreadcrumbs}>Lista de Salas</PageTitle>
      <ListWrapper />
    </>
  )
}

export default RoomPage
